import { useQuery } from '@tanstack/react-query'
import { useParams } from '@tanstack/react-router'
import { useMemo } from 'react'

import { getSearchCasesQuery } from '@/lib/queries/business/v4/case/search/queries'

export const useFindTargetCaseEoir = () => {
  const urlParams = useParams({
    from: '/_app/applicants/$applicantId/cases-eoir/$caseNumber',
  })

  const { data: dataListCase } = useQuery(getSearchCasesQuery({ path_id: Number(urlParams.applicantId), isEoir: true }))
  const targetCase = useMemo(
    () =>
      dataListCase?.cases?.find(
        ({ applicant_path_id, case_number }) =>
          applicant_path_id === Number(urlParams.applicantId) && case_number === urlParams.caseNumber
      ),
    [dataListCase, urlParams.applicantId, urlParams.caseNumber]
  )

  return { targetCase }
}
